// Swarthmore's majors (#2748). Read on 2026-10-01 from the official College
// Bulletin 2026-2027 (catalog.swarthmore.edu, catoid=32). The catalog's pages
// sit behind a browser challenge that blocks plain fetches, so each
// department's entry was read through the catalog's own public widget API
// (catalog id 6 = "College Bulletin 2026-2027"); the SOURCES url is the
// catalog's Departments and Programs page. Section 7 of the Bulletin says
// Swarthmore awards the bachelor of arts, and the bachelor of science only to
// engineering majors; the Bulletin spells the degrees out, so B.A. and B.S.
// are written here as abbreviations. Kept: every course major a department
// or program entry says it offers. Left out: minors, programs that offer only
// a minor or an individualized (special) major (Asian American Studies,
// Gender and Sexuality Studies, Global Studies, Interpretation Theory,
// Islamic Studies, Japanese, Literatures in Translation), and the special
// majors combining two fields (for example Linguistics and Languages, or a
// field with Educational Studies). Swarthmore is one college, so there is
// one group. The KB's majors list was the starting point; the catalog wins.
const majors = {
    slug: 'swarthmore-college',
    read: '2026-10-01',
    intro: 'Every major in Swarthmore\'s official College Bulletin 2026-2027, with the degree it leads to. Minors and individualized majors are left out.',
    groups: [
        {
            name: 'Majors',
            source: {
                label: 'Swarthmore College Bulletin 2026-2027, Departments and Programs',
                url: 'https://catalog.swarthmore.edu/content.php?catoid=32&navoid=2317',
            },
            majors: [
                { name: 'Ancient History', degree: 'B.A.' },
                { name: 'Arabic', degree: 'B.A.' },
                { name: 'Architectural Studies', degree: 'B.A.' },
                { name: 'Art', degree: 'B.A.' },
                { name: 'Art History', degree: 'B.A.' },
                { name: 'Asian Studies', degree: 'B.A.' },
                { name: 'Astronomy', degree: 'B.A.' },
                { name: 'Biochemistry', degree: 'B.A.' },
                { name: 'Biology', degree: 'B.A.' },
                { name: 'Black Studies', degree: 'B.A.' },
                { name: 'Chemistry', degree: 'B.A.' },
                { name: 'Chinese', degree: 'B.A.' },
                { name: 'Classical Studies', degree: 'B.A.' },
                { name: 'Cognitive Science', degree: 'B.A.' },
                { name: 'Comparative Literature', degree: 'B.A.' },
                { name: 'Computer Science', degree: 'B.A.' },
                { name: 'Dance', degree: 'B.A.' },
                { name: 'Economics', degree: 'B.A.' },
                { name: 'Educational Studies', degree: 'B.A.' },
                { name: 'Engineering', degree: 'B.S.' },
                { name: 'English Literature', degree: 'B.A.' },
                { name: 'Environmental Studies', degree: 'B.A.' },
                { name: 'Film and Media Studies', degree: 'B.A.' },
                { name: 'French and Francophone Studies', degree: 'B.A.' },
                { name: 'German Studies', degree: 'B.A.' },
                { name: 'Greek', degree: 'B.A.' },
                { name: 'History', degree: 'B.A.' },
                { name: 'Latin', degree: 'B.A.' },
                { name: 'Latin American and Latino Studies', degree: 'B.A.' },
                { name: 'Linguistics', degree: 'B.A.' },
                { name: 'Mathematics', degree: 'B.A.' },
                { name: 'Medieval Studies', degree: 'B.A.' },
                { name: 'Music', degree: 'B.A.' },
                { name: 'Neuroscience', degree: 'B.A.' },
                { name: 'Peace and Conflict Studies', degree: 'B.A.' },
                { name: 'Philosophy', degree: 'B.A.' },
                { name: 'Philosophy, Politics, and Economics', degree: 'B.A.' },
                { name: 'Physics', degree: 'B.A.' },
                { name: 'Political Science', degree: 'B.A.' },
                { name: 'Psychology', degree: 'B.A.' },
                { name: 'Religion', degree: 'B.A.' },
                { name: 'Russian', degree: 'B.A.' },
                { name: 'Sociology and Anthropology', degree: 'B.A.' },
                { name: 'Spanish', degree: 'B.A.' },
                { name: 'Theater', degree: 'B.A.' },
            ],
        },
    ],
};

export default majors;
